<template>
    <div ref="mapWrap"
         :class="['map-wrap', {'out-system-load': outSistemLoad || hasCountryInfo}]">
        <tour-map @buyTour="buyTour($event)"
                  :rate="rate"
                  :focused="focusedMapItem"
                  :mapItems="mapItems"/>

    </div>
</template>

<script>
    import {bus} from "../../../main";

    import tourMap from "../tourMap";
    export default {
        name: "mapResult",
        components: {
            tourMap
        },
        props: {
            rate: {
                type: Object,
                default: () => {}
            },
            focused: {
                type: Object,
                default: null
            },
            focusedMapItem: {
                type: Object,
                default: null
            },
            mapItems: {
                type: Array,
                default: () => []
            },
            outSistemLoad: {
                type: Boolean,
                default: false
            },
            hasCountryInfo: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                resizeStatus: false,
            }
        },
        created() {
            // bus.$on("fixed-filters", () => {
            //     setTimeout(() => {
            //         this.fixedMap();
            //     }, 0)
            // });
            bus.$on("changeListType", () => {
                setTimeout(() => {
                    this.fixedMap();
                }, 0)
            });
            window.addEventListener("scroll", this.fixedMap);
        },
        mounted() {
            document.querySelector(".leaflet-control-zoom").style.display = "none";
        },
        beforeDestroy() {
            const gridTourResultList = document.querySelector(".grid-tour-result-list");
            gridTourResultList.style.width = "";
            window.removeEventListener("scroll", this.fixedMap);
        },
        methods: {
            fixedMap() {
                const mapWrap = document.querySelector(".map-wrap");
                if (!mapWrap) return;
                const tourResult = document.querySelector(".tour-result").getBoundingClientRect();
                const fixedFilters = document.querySelector("#main-filters.fixed");
                if (fixedFilters || tourResult.top < 0) {
                    mapWrap.style.position = "fixed";
                } else {
                    mapWrap.style.position = "absolute"
                }
            },
            buyTour(e) {
                this.$emit("buyTour", e)
            },
        }
    }
</script>

<style scoped>

    .map-wrap {
        background-color: var(--white-color);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        right: 0;
        height: calc(100vh - 16px);
        margin: 0;
    }

</style>